// 登錄頁面翻譯

export const login = {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    submit: 'Login',
    signInWithGoogle: 'Sign in with Google',
    continueWithEmail: 'Continue with Email',
    enterYourEmail: 'Enter your email',
    sendVerificationCode: 'Send Verification Code',
    sending: 'Sending...',
    verificationCode: 'Verification Code',
    resend: 'Resend',
    resendIn: 'Resend in',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    byContining: 'By continuing, you agree to our',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    signInToAccount: 'Sign in to your account',
    freeTrialAvailable: 'Free trial available after login',
    loginProcessingFailed: 'Login processing failed, please try again',
    googleLoginFailed: 'Google login failed, please try again',
    resendCodeFailed: 'Failed to resend verification code',
    pleaseEnterEmail: 'Please enter your email',
    sendCodeFailed: 'Failed to send verification code',
    enterEmailError: 'Please enter your email',
    enterCodeError: 'Please enter verification code',
    loginFailed: 'Login failed, please check verification code',
    referralInvitation: '{referrerName} invites you to register, you will receive {bonus} points reward after successful registration!',
    accountExistsLoginSuccess: 'Login successful!',
    accountExistsNoReferralPoints: 'Account already exists, Login successful! ',
    loginSuccessful: 'Login successful!',
    loginFailedGeneric: 'Login failed',
    registrationSuccessful: 'Registration successful!',
    registrationFailedGeneric: 'Registration failed',
    loggedOutSuccessfully: 'Logged out successfully',
    googleLoginSuccessful: 'Google login successful!',
    googleLoginFailedGeneric: 'Google login failed',
    googleLoginFailedNoAuthCode: 'Google login failed - No authorization code received',
    googleLoginFailedError: 'Google login failed',
    googleLoginFailedAccessDenied: 'User cancelled Google login authorization'
  };
